import { render, staticRenderFns } from "./control-bar.vue?vue&type=template&id=7c8fa127&scoped=true&"
import script from "./control-bar.vue?vue&type=script&lang=js&"
export * from "./control-bar.vue?vue&type=script&lang=js&"
import style0 from "./control-bar.vue?vue&type=style&index=0&id=7c8fa127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8fa127",
  null
  
)

export default component.exports